import { getBundleDiscountOnCurrentOffer } from '@/features/bundleDiscount/bundleDiscount.utils'
import { type OfferRecommendationFragment } from '@/services/graphql/generated'
import { type Money } from '@/utils/formatter'

export function getPriceMatchMonthlySavingsWithBundleDiscount(
  offer: Pick<OfferRecommendationFragment, 'cost'>,
  priceMatch: NonNullable<OfferRecommendationFragment['priceMatch']>,
): Money {
  return {
    amount: priceMatch.priceReduction.amount + Math.abs(getBundleDiscountOnCurrentOffer(offer)?.amount.amount ?? 0),
    currencyCode: priceMatch.priceReduction.currencyCode,
  }
}
